import { InvoiceStatus } from '@features/invoicesLegacy/enums/invoiceStatus'

import { InvoicesSummaryData } from '../types/invoicesSummaryData'

export const getAmountForStatusAll = (data: InvoicesSummaryData) => data[InvoiceStatus.All].amount
